'use client'

import { JSX, PropsWithChildren } from 'react'

import { RENT_BUTTON_CLICK_EVENT } from 'app/utils/events'
import { RentActionButton } from 'components/partials/products/RentButton/styles'

const RentalButtonClient = ({ children }: PropsWithChildren): JSX.Element => {
  const handleClick = () => {
    window.dispatchEvent(new Event(RENT_BUTTON_CLICK_EVENT))
    document.body.style.overflow = 'hidden'
  }

  return <RentActionButton onClick={handleClick}>{children}</RentActionButton>
}

export default RentalButtonClient
